import React, { forwardRef } from 'react';
const Input = forwardRef(function Input({ variant, testId = 'store-input', ...otherProps }, ref) {
    const variants = {
        'data-error': variant === 'error' || undefined,
        'data-success': variant === 'success' || undefined,
    };
    return (React.createElement("input", Object.assign({ ref: ref, "data-store-input": true, "data-testid": testId }, variants, otherProps)));
});
export default Input;
//# sourceMappingURL=Input.js.map